import { FuelAvatar, FuelDivider, FuelTag, FuelTypography } from '@frete.com/fuel-react';
import React, { FC } from 'react';
import { ILastSearchedDriverInfoProps } from './types';
import * as Styled from './styled';

const DriverInfo: FC<ILastSearchedDriverInfoProps> = ({ driverInfo, showDivider, onClick }) => (
  <>
    <Styled.Wrapper onClick={onClick}>
      <FuelAvatar size="default" verified={driverInfo.isVerified}>
        <Styled.NameWrapper slot="title">
          <FuelTypography size="body-sm" color="neutral-strong" weight="bold">
            {driverInfo.name.toLowerCase()}
          </FuelTypography>
        </Styled.NameWrapper>
        <FuelTypography slot="description">
          {driverInfo.vehicle.tractor} {driverInfo.vehicle.body ? ` • ${driverInfo.vehicle.body}` : ''}
        </FuelTypography>

        {driverInfo.isVip && (
          <Styled.TagWrapper slot="tag" data-testid="driver-info-vip">
            <FuelTag label="VIP" icon="diamond" iconStyle="filled" shape="rectangle" uppercase highlight />
          </Styled.TagWrapper>
        )}
      </FuelAvatar>
    </Styled.Wrapper>
    {showDivider && (
      <Styled.DividerWrapper>
        <FuelDivider size="default" orientation="horizontal" data-testid="driver-info-divider" />
      </Styled.DividerWrapper>
    )}
  </>
);

export default DriverInfo;
